module.exports = __webpack_public_path__ + "img/link-copied.99c242ef.svg";